import React from 'react';
import { useTheme } from '@mui/material';
import { MarketBanner } from '@market/react';

const ProductNotificationBanner = ({ cart }) => {
  const theme = useTheme();

  if (!cart) return null;

  const messages = cart.flatMap((item) =>
    item.notifications ? Object.values(item.notifications) : [],
  );

  if (messages.length === 0) return null;

  const message = messages.reduce((memoMessage, currentMessage, index) => {
    const bulletPoint = messages.length > 1 ? '• ' : '';
    const ending = messages.length - 1 === index ? '' : '\n';
    return `${memoMessage}${bulletPoint}${currentMessage}${ending}`;
  }, '');

  return (
    <MarketBanner
      variant="info"
      style={{
        margin: theme.spacing(2, 0),
        whiteSpace: 'pre-line',
      }}
    >
      {message}
    </MarketBanner>
  );
};

export default ProductNotificationBanner;
